import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link/Link';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import InViewObserver from 'components/InViewObserver';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Image from '../../../../../components/Image';
import LoadableComponentLoader from '../../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import { TOI_LIVE_DOMAIN, TOI_IMAGE_DOMAIN } from '../../../../../constants';
import ShareButton from '../ShareButton/ShareButton';
import { msToTime } from '../../../../../utils/common';
import s from './GameCard.scss';

const GameCard = props => {
  const {
    widgetUsedOn,
    calledFrom,
    isMobile,
    gameType,
    isVertical,
    // isHowtoPlayVisible,
    gameCategoryConfigData,
    data,
    ga4Category,
    gameId,
    gameLevel,
    subSection,
    pageTemplate,
    gaLabel = '',
  } = props;
  const componentData = props?.data ? props.data : '';
  const isServerSide = calledFrom === 'ssr_homepage';
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  if (!componentData) {
    return null;
  }

  const fireGaOnClick = label => {
    const gaData = {
      event: 'user_click_games',
      type: `${
        gameType === 'loop-a-loop'
          ? 'loop_the_loop'
          : gameType?.replace(/-/g, '_')
      }_widget`,
      label: label || 'N/A',
      page_template: pageTemplate || 'gameplay',
      section: 'games',
      subsection:
        subSection === 'loop-a-loop'
          ? 'loop_the_loop'
          : subSection?.replace(/-/g, '_'),
      browsing_platform: isMobile ? 'mweb' : 'web',
      level: gameLevel || 'N/A',
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ga4Category) {
      gaData.category = ga4Category;
    }
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (gameId) {
      gaData.game_id = gameId;
    }
    if (label) {
      gaData.label = label;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_click_games', gaData);
  };

  if (isServerSide) {
    return (
      <InViewObserver>
        <Link
          className={`${s.cardLink}`}
          // to={`${TOI_LIVE_DOMAIN}/games/${gameType}/today`}
          to={`${TOI_LIVE_DOMAIN}/games/${gameType}/today${
            !!widgetUsedOn && widgetUsedOn !== '' && widgetUsedOn === 'homepage'
              ? '?utm_source=toi_homepage&utm_medium=game_banner&utm_campaign=game_promotion'
              : ''
          }`}
          onClick={() => {
            fireGaOnClick(gaLabel);
          }}
        >
          <div
            className={`${s.gameCard} gameCard ${s.br16} ${
              isVertical ? s.horizontal : ''
            }`}
            style={{ background: componentData?.backgroundColor }}
          >
            <div className={s.topArea}>
              <div className={s.left}>
                <figure>
                  <Image
                    src={componentData?.imageUrl}
                    placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/111258810.cms`}
                    alt={componentData?.title}
                    // lazyload
                    offsetVertical={200}
                  />
                </figure>
              </div>
              <div className={s.right}>
                <h2>{componentData?.title}</h2>
                <span>{componentData?.caption}</span>
              </div>
            </div>
            <div className={s.btnGroup}>
              <div className={`${s.btnPrimary} ${s.br8}`}>
                Play Now <i className={s.arrowRight} />
              </div>
              {isMobile ? (
                <div className={`${s.share} ${s.br8}`}>
                  <LoadableComponentLoader
                    loadableComponentName="SocialSharingMobile"
                    isParent={false}
                    url={`${TOI_LIVE_DOMAIN}/games/${gameType}/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                    title={componentData?.gameType}
                    nativeIconClassName="nativeIcon"
                    via="@timesofindia"
                    isTablet={false}
                    hideSharingButtons
                    hideSharingNative
                    placeHolderLoaderClass="follow_us_loader"
                    hideFollow
                    gaOnClick={() => {
                      fireGaOnClick();
                    }}
                  />
                </div>
              ) : (
                <div className={`${s.share} ${s.br8}`}>
                  <ShareButton
                    nativeIconClassName="nativeIcon"
                    title={componentData?.gameType}
                    url={`${TOI_LIVE_DOMAIN}/games/${gameType}/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                    gaOnClick={() => {
                      fireGaOnClick();
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </Link>
      </InViewObserver>
    );
  }

  const [imageUrl, setImageUrl] = useState('');
  const [subStatus, setSubStatus] = useState('');
  const [isFinished, setIsFinished] = useState(false);

  useEffect(
    () => {
      if (calledFrom && calledFrom === 'more_games_congratulations') {
        setImageUrl(gameCategoryConfigData?.listingIconUrl?.imageUrl);
        setSubStatus('');
        return;
      }
      const gameStatuses =
        data && Array.isArray(data.gameStatus) ? data.gameStatus : [];
      const allFinished = gameStatuses.every(status => status.hasPlayed);
      const anyPaused = gameStatuses.some(status => status.hasPaused);
      const getLocalStorageKeyPrefix = gameTypeVar => {
        switch (gameTypeVar) {
          case 'sudoku':
            return 'tilsudoku';
          case 'location-guesser':
            return 'tillocationguesser';
          case 'loop-a-loop':
            return 'tilloopaloop';
          case 'whos-that':
            return 'tilwhoisthat';
          case 'connect':
            return 'tilconnect';
          default:
            return 'tilstate';
        }
      };

      const anyPausedInLocalStorage = gameStatuses.some(status =>
        localStorage.getItem(
          `${getLocalStorageKeyPrefix(gameType)}:${status.gameId}`,
        ),
      );

      if (allFinished) {
        setImageUrl(gameCategoryConfigData?.listingIconUrl?.finishImageUrl);
        setIsFinished(true);
        const lastFinishedGame = gameStatuses.find(
          status => status.completionTimeinMills,
        );
        if (lastFinishedGame) {
          setSubStatus(msToTime(lastFinishedGame.completionTimeinMills));
        }
        if (!!gameType && gameType === 'location-guesser') {
          const tempguessPoints = gameStatuses.find(
            guessPoints => guessPoints.bestGuessPoints,
          );
          if (tempguessPoints) {
            setSubStatus(tempguessPoints.bestGuessPoints);
          }
        }
        if (!!gameType && gameType === 'whos-that') {
          const temptotalScore = gameStatuses.find(
            totalScore => totalScore.totalScore,
          );
          if (temptotalScore) {
            setSubStatus(temptotalScore.totalScore);
          }
        }
      } else if (anyPaused || anyPausedInLocalStorage) {
        setImageUrl(gameCategoryConfigData?.listingIconUrl?.pauseImageUrl);
        setSubStatus('paused');
      } else {
        setImageUrl(gameCategoryConfigData?.listingIconUrl?.imageUrl);
        setSubStatus('');
      }
    },
    [data, calledFrom],
  );

  const onView = () => {
    const gaData = {
      event: 'user_shown_games',
      type: `${
        gameType === 'loop-a-loop'
          ? 'loop_the_loop'
          : gameType?.replace(/-/g, '_')
      }_widget`,
      page_template: pageTemplate || 'gameplay',
      section: 'games',
      subsection:
        subSection === 'loop-a-loop'
          ? 'loop_the_loop'
          : subSection?.replace(/-/g, '_'),
      browsing_platform: isMobile ? 'mweb' : 'web',
      level: gameLevel || 'N/A',
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ga4Category) {
      gaData.category = ga4Category;
    }
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (gameId) {
      gaData.game_id = gameId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  return (
    <InViewObserver inViewCallback={onView}>
      <Link
        className={`${s.cardLink}`}
        // to={`${TOI_LIVE_DOMAIN}/games/${gameType}/today`}
        to={`${TOI_LIVE_DOMAIN}/games/${gameType}/today${
          !!widgetUsedOn && widgetUsedOn !== '' && widgetUsedOn === 'homepage'
            ? '?utm_source=toi_homepage&utm_medium=game_banner&utm_campaign=game_promotion'
            : ''
        }`}
        onClick={() => {
          fireGaOnClick(gaLabel);
        }}
      >
        <div
          className={`${s.gameCard} ${s.br16} ${
            isVertical ? s.horizontal : ''
          }`}
          style={{ background: componentData.backgroundColor }}
        >
          {data &&
            data.streakInfo &&
            data.streakInfo.text && (
              <div className={s.gameStreak}>
                <div className={s.streakDay}>
                  <i className={s.smallFireIcon} />
                  {data.streakInfo.text}
                </div>
              </div>
            )}
          <div className={s.topArea}>
            <div className={s.left}>
              <figure>
                <Image
                  src={imageUrl}
                  placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/111258810.cms`}
                  alt={componentData.title}
                  lazyload={
                    !(
                      (widgetUsedOn && widgetUsedOn === 'homepage') ||
                      calledFrom === 'more_games_congratulations' ||
                      calledFrom === 'game_listing'
                    )
                  }
                  offsetVertical={200}
                />
              </figure>
              {isFinished && <i className={s.greenTickIcon} />}
              {subStatus && <span className={s.gameStatus}>{subStatus}</span>}
            </div>
            <div className={s.right}>
              {!(
                widgetUsedOn &&
                widgetUsedOn !== '' &&
                widgetUsedOn === 'homepage'
              ) &&
                gameType === 'whos-that' && (
                  <strong
                    className={`${s.newTag} ${
                      gameType === 'whos-that' ? s.whosThatNewTag : ''
                    }`}
                  >
                    New
                  </strong>
                )}
              <h2>{componentData.title}</h2>
              <span>{componentData.caption}</span>
            </div>
          </div>
          <div className={s.btnGroup}>
            {/* {isHowtoPlayVisible && (
            <Link
              className={s.howtoplay}
              to={`${TOI_LIVE_DOMAIN}/games/${gameType}`}
            >
              How to Play
            </Link>
          )} */}
            {/* <Link
              className={`${s.btnPrimary} ${s.br8}`}
              to={`${TOI_LIVE_DOMAIN}/games/${gameType}/today`}
              onClick={() => {
                fireGaOnClick('play_now');
              }}
            > */}
            <div className={`${s.btnPrimary} ${s.br8}`}>
              Play Now <i className={s.arrowRight} />
            </div>
            {/* </Link> */}
            {isMobile ? (
              <div className={`${s.share} ${s.br8}`}>
                <LoadableComponentLoader
                  loadableComponentName="SocialSharingMobile"
                  isParent={false}
                  url={`${TOI_LIVE_DOMAIN}/games/${gameType}/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                  title={componentData.gameType}
                  nativeIconClassName="nativeIcon"
                  via="@timesofindia"
                  isTablet={false}
                  hideSharingButtons
                  hideSharingNative
                  placeHolderLoaderClass="follow_us_loader"
                  hideFollow
                  gaOnClick={() => {
                    fireGaOnClick();
                  }}
                />
              </div>
            ) : (
              <div className={`${s.share} ${s.br8}`}>
                <ShareButton
                  nativeIconClassName="nativeIcon"
                  title={componentData.gameType}
                  url={`${TOI_LIVE_DOMAIN}/games/${gameType}/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                  gaOnClick={() => {
                    fireGaOnClick();
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Link>
    </InViewObserver>
  );
};

GameCard.propTypes = {
  isMobile: PropTypes.bool,
  isVertical: PropTypes.bool,
  gameCategoryConfigData: PropTypes.shape({}),
  gameId: PropTypes.string,
};

GameCard.defaultProps = {
  isMobile: false,
  isVertical: false,
  gameCategoryConfigData: {},
  gameId: '',
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});
export default connect(mapStateToProps)(GameCard);
